var amdi18n={"__root":{"beta_feedback":"Beta Feedback","code":"Code","operations":"Operations","documentation":"Documentation","code_libraries":"Code Libraries","imp_api_reference":"imp API Reference","squirrel_reference":"Squirrel Reference","pin_mux":"Pin Mux","example_code":"Example Code","developer_guides":"Developer Guides","ide_user_guide":"IDE User Guide","ide_new_user_guide":"IDE New User Guide","ops_console_user_guide":"Ops User Guide","webhooks":"Webhooks","device_information":"Device Information","blessing_overview":"Factory Overview","blessing_api_reference":"Factory API Reference","forums":"Forums","profile":"Profile","build_api_keys":"Build API Keys","invite_new_user":"Invite New User","logout":"Logout","collaborators":"Collaborators","link_to_preview":"Preview impCentral","link_to_production":"Go Back to IDE"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;